import React from 'react';

interface ComingSoonProps {
  isOpen: boolean;
  onClose: () => void;
}

const ComingSoon: React.FC<ComingSoonProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      onClick={onClose}
    >
      <div 
        className="bg-white rounded-lg p-6 shadow-lg transform transition-all max-w-sm w-full mx-4"
        onClick={e => e.stopPropagation()}
      >
        <div className="text-center">
          <div className="text-6xl mb-4">🚧</div>
          <h3 className="text-xl font-semibold mb-2">Coming Soon!</h3>
          <p className="text-gray-600 mb-4">This feature is under development and will be available soon.</p>
          <button
            onClick={onClose}
            className="px-4 py-2 bg-[#42E56F] text-[#222222] rounded-lg hover:bg-[#3bd665] transition-colors"
          >
            Got it
          </button>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon; 